import React, { useState } from 'react'

import ArchiveIcon from '@mui/icons-material/Archive'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import { IconButton, Tooltip } from '@mui/material'

import { exportFile } from 'actions/app-actions'
import { ConfirmModal } from 'components/_base/index'
import CampaignBannerEdit from 'components/campaign-banners/CampaignBannerEdit'
import { useAppDispatch } from 'hooks/useAppDispatch'
import { useDeleteBanner } from 'hooks/useCampaignBanners'

type CampaignBannersTableActionsProps = {
  banner: any
  campaignId: string
  customerId: number
}

const CampaignBannersTableActions = ({ banner, campaignId, customerId }: CampaignBannersTableActionsProps) => {
  const dispatch = useAppDispatch()
  const deleteBanner = useDeleteBanner()
  const [editModal, setEditModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)

  const handleDownload = () => dispatch(exportFile({ url: banner.url.download }))
  const handleDelete = () => deleteBanner.mutate({ bannerId: banner.id, campaignId, type: banner.type })

  // The edit form closes via onClose(callback): close the modal, then run the submit callback.
  const handleEditClose = (callback = () => {}) => {
    setEditModal(false)
    callback()
  }

  return (
    <div className="campaign-banners-table__actions">
      <Tooltip title="Download">
        <IconButton aria-label="Download" onClick={handleDownload} size="large">
          <ArchiveIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Edit">
        <IconButton aria-label="Edit" onClick={() => setEditModal(true)} size="large">
          <EditIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Delete">
        <IconButton aria-label="Delete" onClick={() => setDeleteModal(true)} size="large">
          <DeleteIcon />
        </IconButton>
      </Tooltip>
      {editModal && (
        <CampaignBannerEdit
          banner={banner}
          customerId={customerId}
          id={campaignId}
          onClose={handleEditClose}
          open={editModal}
        />
      )}
      <ConfirmModal
        onClose={() => setDeleteModal(false)}
        onConfirm={() => {
          setDeleteModal(false)
          handleDelete()
        }}
        open={deleteModal}
        title="Confirm delete banner"
      />
    </div>
  )
}

export default CampaignBannersTableActions
